export default __webpack_public_path__ + "static/media/left-heading.png?.79336dea";